import React from "react";
import LoaderSvg from "./LoaderSvg";

const Loader = ({
  size = 48,
  color = "#040ca5",
  withContainer = false,
  containerStyle = {},
  text = false,
  className = "",
}) => (
  <div
    className={
      className +
      "  d-flex align-items-center justify-content-center flex-column " +
      (withContainer ? "w-100 " : "")
    }
    style={containerStyle}
  >
    <LoaderSvg color={color} size={size} />
    {text && <b className="my-3">{text}</b>}
  </div>
);

export default Loader;
